import { useEffect } from 'react';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import UILink from 'UIComponents/link/UILink';
import { getFeatureTranslation } from '../../utils/translations';
import { getSubscriptionTranslation } from '../../utils/translations';
import { trackViewResurrectionBanner } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ResurrectionBannerNonEmptyState = ({
  featureLimitName,
  endDate,
  featureLoss,
  featureLimit,
  productApiName,
  onClose,
  buttonSlot,
  autoRenewSuccessful
}) => {
  const endDateShortFormat = I18n.moment(endDate).format('ll');
  useEffect(() => {
    trackViewResurrectionBanner(featureLimitName);
  }, [featureLimitName]);
  return /*#__PURE__*/_jsx(UIAlert, {
    className: "m-bottom-4",
    type: "warning",
    titleText: autoRenewSuccessful ? I18n.text('resurrectionBanner.nonEmptyState.titleAutoRenewal') : I18n.text('resurrectionBanner.nonEmptyState.title'),
    closeable: true,
    onClose: onClose,
    children: autoRenewSuccessful ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'resurrectionBanner.nonEmptyState.messageAutoRenewal_jsx',
      elements: {
        UILink
      },
      options: {
        subscriptionName: getSubscriptionTranslation(productApiName),
        linkProps: {
          href: `/account-and-billing/${PortalIdParser.get()}/v2/subscriptions`
        }
      }
    }) : /*#__PURE__*/_jsxs(UIButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: 'resurrectionBanner.nonEmptyState.message_jsx',
        elements: {
          strong: 'strong'
        },
        options: {
          endDate: endDateShortFormat,
          featureLimitName: getFeatureTranslation(featureLimitName),
          featureLoss,
          featureLimit
        }
      }), buttonSlot]
    })
  });
};